import { Box, FormControl, MenuItem, Select, Typography } from '@mui/material';
import { OrderNumberDialogSelectProps } from './OrderNumberDialogSelect.types';

export function OrderNumberDialogSelect({
  label,
  value,
  options,
  placeholder,
  disabled,
  onChange
}: OrderNumberDialogSelectProps) {
  return (
    <Box className="order-number-dialog-field-group">
      <Typography className="order-number-dialog-field-label">{label}</Typography>
      <FormControl fullWidth size="small">
        <Select
          className="order-number-dialog-select"
          displayEmpty
          disabled={disabled}
          value={value}
          onChange={onChange}
        >
          <MenuItem value="">
            <em>{placeholder}</em>
          </MenuItem>
          {options.map(option => (
            <MenuItem key={option.id} value={option.id}>
              {option.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
